<template>
  <form @change="logChangeData">
    <div class="setting_content">
      <div class="setting_content_main">
        <h2 class="setting_content_title">
          {{ buttonLabelsProperties.TAB_HEADER }}
        </h2>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ buttonLabelsProperties.ENTRY_BUTTON_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ buttonLabelsProperties.BUTTON_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="[
                  [buttonLabelsProperties.ENTRY_BUTTON_PLACEHOLDER],
                ]"
                v-model="draftButton.entryButton"
                @change="validateEnterButton()"
              />
              <h6 v-show="lengthErrorEntryButton" class="error-message">
                {{
                  buttonSettingsProperties.ENTRY_BUTTON_MAX_LENGTH +
                  errorProperties.MAX_LENGTH_CHARACTER_MESSAGE
                }}
              </h6>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ buttonLabelsProperties.CONFIRM_BUTTON_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ buttonLabelsProperties.BUTTON_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="buttonLabelsProperties.CONFIRM_BUTTON_PLACEHOLDER"
                v-model="draftButton.confirmButton"
                @change="validateConfirmButton()"
              />
              <h6 v-show="lengthErrorConfirmButton" class="error-message">
                {{
                  buttonSettingsProperties.CONFIRM_BUTTON_MAX_LENGTH +
                  errorProperties.MAX_LENGTH_CHARACTER_MESSAGE
                }}
              </h6>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ buttonLabelsProperties.RETURN_BUTTON_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ buttonLabelsProperties.BUTTON_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="buttonLabelsProperties.RETURN_BUTTON_PLACEHOLDER"
                v-model="draftButton.returnButton"
                @change="validateReturnButton()"
              />
              <h6 v-show="lengthErrorReturnButton" class="error-message">
                {{ buttonSettingsProperties.RETURN_BUTTON_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import buttonSettingsProperties from "../../../properties/entry_screen/button_tab/button-maxlength-settings.json";
import buttonLabelsProperties from "../../../properties/entry_screen/button_tab/button-labels.json";
import errorProperties from "../../../properties/entry_screen/errors.json";

export default {
  name: "ButtonTab",
  props: ["button", "buttonError"],
  data() {
    return {
      lengthErrorEntryButton: false,
      lengthErrorConfirmButton: false,
      lengthErrorReturnButton: false,
      draftButton: {
        entryButton: "",
        confirmButton: "",
        returnButton: "",
      },
      buttonSettingsProperties: buttonSettingsProperties,
      buttonLabelsProperties: buttonLabelsProperties,
      errorProperties: errorProperties,
    };
  },
  watch: {
    draftButton: {
      handler() {
        this.validateEnterButton();
        this.validateConfirmButton();
        this.validateReturnButton();
        this.logChangeData();
      },
      deep: true,
    },
  },
  computed: {
    computedBtnError: {
      get() {
        return this.buttonError;
      },
      set(val) {
        this.$emit("updateBtnError", val);
      },
    },
  },
  mounted() {
    this.validateEnterButton();
    this.validateConfirmButton();
    this.validateReturnButton();
    this.draftButton = this.button;
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    validateEnterButton() {
      this.lengthErrorEntryButton =
        this.draftButton.entryButton.length >
        this.buttonSettingsProperties.ENTRY_BUTTON_MAX_LENGTH;
      if (!this.lengthErrorEntryButton) {
        this.button.entryButton = this.draftButton.entryButton;
      }

      this.checkError();
    },

    validateConfirmButton() {
      this.lengthErrorConfirmButton =
        this.draftButton.confirmButton.length >
        this.buttonSettingsProperties.CONFIRM_BUTTON_MAX_LENGTH;
      if (!this.lengthErrorConfirmButton) {
        this.button.confirmButton = this.draftButton.confirmButton;
      }

      this.checkError();
    },

    validateReturnButton() {
      this.lengthErrorReturnButton =
        this.draftButton.returnButton.length >
        this.buttonSettingsProperties.RETURN_BUTTON_MAX_LENGTH;
      if (!this.lengthErrorReturnButton) {
        this.button.returnButton = this.draftButton.returnButton;
      }

      this.checkError();
    },

    checkError() {
      this.computedBtnError =
        this.lengthErrorEntryButton ||
        this.lengthErrorConfirmButton ||
        this.lengthErrorReturnButton;
    },
  },
};
</script>
